import { Children, cloneElement, isValidElement, type ReactElement, type ReactNode } from 'react';
import { Group as TMGroup, type GroupProps as TMGroupProps } from 'tamagui';

export type GroupProps = TMGroupProps & {
  separator?: ReactElement;
};

const interleaveChildren = (children: ReactNode, separator: ReactElement): ReactNode[] => {
  const filtered = Children.toArray(children).filter(isValidElement);

  return filtered.flatMap((child, index) =>
    index === 0 ? [child] : [cloneElement(separator, { key: `separator-${index}` }), child]
  );
};

export const Group = ({ separator, children, ...props }: GroupProps) => {
  const content = separator ? interleaveChildren(children, separator) : children;

  return (
    <TMGroup render={'ul'} borderRadius={'$4'} {...props}>
      {content}
    </TMGroup>
  );
};

Group.displayName = 'Group';
Group.Item = TMGroup.Item;
